import { render, staticRenderFns } from "./orderParam.vue?vue&type=template&id=1d8738fd&scoped=true"
import script from "./orderParam.vue?vue&type=script&lang=js"
export * from "./orderParam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8738fd",
  null
  
)

export default component.exports